import {
  INPUT_SAMPLE_TICKS,
  type InputControl,
  type LegacyGame,
} from "../lib/game";
import type { TopOutMessage } from "../lib/net";

/**
 * Quantize an input edge to a 24Hz boundary. Edges for the same control remain
 * one sample apart, so a rapid down/up/down cannot end in the wrong held state.
 */
export function quantizeInputTransitionTick(
  startTick: number,
  currentTick: number,
  control: InputControl,
  queuedInputs: readonly { applyBeforeTick: number; control: InputControl }[],
): number {
  const elapsed = Math.max(0, currentTick - startTick);
  const nextSampleTick =
    startTick + (Math.floor(elapsed / INPUT_SAMPLE_TICKS) + 1) * INPUT_SAMPLE_TICKS;
  const lastForControl = [...queuedInputs]
    .reverse()
    .find((queued) => queued.control === control);
  return lastForControl && lastForControl.applyBeforeTick >= nextSampleTick
    ? lastForControl.applyBeforeTick + INPUT_SAMPLE_TICKS
    : nextSampleTick;
}

export function isVerifiedRemoteTopOut(
  verifier: LegacyGame | undefined,
  message: Pick<TopOutMessage, "finalStateHash" | "lastLockSeq" | "topOutTick">,
): boolean {
  return Boolean(
    verifier &&
    verifier.topOut &&
    verifier.tick === message.topOutTick &&
    verifier.lastLockSeq === message.lastLockSeq &&
    verifier.stateHash() === message.finalStateHash,
  );
}

/** The caller must send InputBatch only when this state mutation succeeds. */
export function applyInputToActiveGame(
  game: LegacyGame,
  control: InputControl,
  held: boolean,
  inputSequence: number,
): boolean {
  if (game.topOut) return false;
  return game.setInput(control, held, inputSequence);
}
